<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else class="DetailStore">
    <h1 class="text-center" style="margin-top: 3%">Store Master</h1>
    <div class="group-1" style="margin-bottom: 5rem">
      <div class="row ln1" style="margin-top: 5%">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Short name</div>
          <h6>{{ checkEmptyValue(objStore.shortName) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Name</div>
          <h6>{{ checkEmptyValue(objStore.name) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Store display name</div>
          <h6>{{ checkEmptyValue(objStore.displayName) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Store code</div>
          <h6>{{ checkEmptyValue(objStore.storeCode) }}</h6>
        </div>
      </div>
      <div class="row ln2">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Brand code</div>
          <h6>{{ checkEmptyValue(objStore.brandCode) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Brand Name</div>
          <h6>{{ checkEmptyValue(objStore.brandName) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Status</div>
          <h6>{{ objStore.status }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Country</div>
          <h6>{{ checkEmptyValue(objStore.country) }}</h6>
        </div>
      </div>
      <div class="row ln2-1">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Self Owned</div>
          <h6>{{ checkEmptyValue(objStore.selfOwned) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Source</div>
          <h6>{{ checkEmptyValue(objStore.source) }}</h6>
        </div>
      </div>
    </div>
    <div class="group-2" style="margin-bottom: 5rem">
      <div class="row ln3">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Address line 1</div>
          <h6>{{ checkEmptyValue(objStore.addressLine1) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Address line 2</div>
          <h6>{{ checkEmptyValue(objStore.addressLine2) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>District</div>
          <h6>{{ checkEmptyValue(objStore.district) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>City</div>
          <h6>{{ checkEmptyValue(objStore.city) }}</h6>
        </div>
      </div>
      <div class="row ln4">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Province</div>
          <h6>{{ checkEmptyValue(objStore.province) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Zip</div>
          <h6>{{ checkEmptyValue(objStore.zip) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Phone</div>
          <h6>{{ checkEmptyValue(objStore.phone) }}</h6>
        </div>
      </div>
      <div class="row ln5">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Store type Code</div>
          <h6>{{ checkEmptyValue(objStore.storeTypeCode) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Store type name</div>
          <h6>{{ checkEmptyValue(objStore.storeType) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Reference Department store code</div>
          <h6>{{ checkEmptyValue(objStore.referenceDepartmentStoreCode) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Reference Department store Name</div>
          <h6>{{ checkEmptyValue(objStore.referenceDepartmentStoreName) }}</h6>
        </div>
      </div>
      <div class="row ln6">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Channel Code</div>
          <h6>{{ checkEmptyValue(objStore.channelCode) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Channel Name</div>
          <h6>{{ checkEmptyValue(objStore.channelName) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Retailer Code</div>
          <h6>{{ checkEmptyValue(objStore.retailerCode) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>Retailer Name</div>
          <h6>{{ checkEmptyValue(objStore.retailerName) }}</h6>
        </div>
      </div>
    </div>
    <div class="group-3">
      <div class="row ln7">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>StoreGroupCode1</div>
          <h6>{{ checkEmptyValue(objStore.storeGroupCode1) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>StoreGroupName1</div>
          <h6>{{ checkEmptyValue(objStore.storeGroupName1) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>StoreGroupCode2</div>
          <h6>{{ checkEmptyValue(objStore.storeGroupCode2) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>StoreGroupName2</div>
          <h6>{{ checkEmptyValue(objStore.storeGroupName2) }}</h6>
        </div>
      </div>
      <div class="row ln8">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>StoreGroupCode3</div>
          <h6>{{ checkEmptyValue(objStore.storeGroupCode3) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>StoreGroupName3</div>
          <h6>{{ checkEmptyValue(objStore.storeGroupName3) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>StoreGroupCode4</div>
          <h6>{{ checkEmptyValue(objStore.storeGroupCode4) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>StoreGroupName4</div>
          <h6>{{ checkEmptyValue(objStore.storeGroupName4) }}</h6>
        </div>
      </div>
      <div class="row ln9">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>StoreGroupCode5</div>
          <h6>{{ checkEmptyValue(objStore.storeGroupCode5) }}</h6>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-6">
          <div>StoreGroupName5</div>
          <h6>{{ checkEmptyValue(objStore.storeGroupName5) }}</h6>
        </div>
      </div>
    </div>
    <div class="row footer">
      <div class="col text-right">
        <button  v-if="isServiceReservationEnabled"
          class="btn btn-success me-2"
          @click="
            redirectToCounterService(
              objStore.brandCode,
              objStore.brandName,
              objStore.storeCode,
              objStore.name,
              objStore.displayName
            )
          "
        >
          Counter Service
        </button>
        <button class="btn btn-primary text-white" @click="$router.go(-1)">
          Back
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import StoreService from "@/services/api/store.service";
export default {
  computed: {
    isServiceReservationEnabled() {
      return process.env.VUE_APP_FEATURE_SERVICE_RESERVATION_ENABLED === 'true';
    },
  },
  data() {
    return {
      storeCode: this.$route.query.id,
      objStore: {},
      isLoading: false,
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      this.isLoading = true;
      try {
        await StoreService.getDetailStore(this.storeCode)
          .then((res) => {
            const data = res.data;
            this.objStore = data.store;
            this.isLoading = false;
          })
          .catch((err) => {
            console.log("Catch API: ", err);
            this.isLoading = false;
          });
      } catch (error) {
        console.log("Error: ", error);
        this.isLoading = false;
      }
    },
    redirectToCounterService(
      brandCode,
      brandName,
      storeCode,
      name,
      displayName
    ) {
      const storeDetails = {
        brandCode,
        brandName,
        storeCode,
        name,
        displayName,
      };
      sessionStorage.setItem("storeDetails", JSON.stringify(storeDetails));
      this.$router.push({
        name: "CounterService",
      });
    },
    checkEmptyValue(val) {
      return val || "N/A";
    },
  },
};
</script>
